import React from"react";
import"./FlipCard.css";

const FlipCard = ({ title, subtitle, image, description }) => {
 return (
 <div className="card">
 <div className="front-page">
 <img src={image} alt={title} className="card-image" />
 <div className="card-info">
 <h2 className="card-title">{title}</h2>
 <p className="card-subtitle">{subtitle}</p>
 </div>
 </div>

 <div className="back-page">
 <div className="card-content">
 <h3>{title}</h3>
 <p className="card-description">{description}</p>
 <button className="card-button">Explore More</button>
 </div>
 </div>
 </div>
 );
};

export default FlipCard;



